module.exports = __webpack_public_path__ + "img/banner1.3abd775d.png";